export class VerticalSolution {
    Signature: string;
    Description: string;
    wsUrl: string;
    Active: boolean;
    wsNotActive: boolean;
    ZucchettiCode: string;
    ResellerCountry: string;
    ResellerCompanyName: string;
    ResellerCode: string;
    IsWSRest: string;
}
